var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinanceInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 191 190.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:#707070;}.cls-1{stroke:#707070;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.56,191.66l-1.81,0A94.33,94.33,0,0,1,3,95.74C4,43.83,47.16,2.38,99.25,3.36s93.7,44,92.73,95.9a94.33,94.33,0,0,1-94.42,92.4Zm-.1-176.53C52.57,15.13,15.64,51.07,14.8,96A82.53,82.53,0,0,0,96,179.85,82.54,82.54,0,0,0,180.2,99l5.89.11L180.2,99C181,53.63,144.63,16,99,15.15Z",
    transform: "translate(-2 -2.34)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    className: "cls-2",
    d: "M104.13,136.28c-3.23,21.08-35.92,22.65-33.62-5.47,1.38-18.75,3.68-36.7,5.52-55.44.93-11.71-3.68-7.81-7.36-10.16-2.77-2.35-2.77-7.81.46-8.59a116.45,116.45,0,0,1,23.45-.78c2.77,0,4.14,2.35,4.14,6.25A42.08,42.08,0,0,1,96.26,73c-1.84,17.89-4.61,36.71-5.52,53.89-.46,4,0,10.93,3.22,10.93a28.14,28.14,0,0,0,7.37-4.69C103.21,131.61,104.13,133.94,104.13,136.28Z",
    transform: "translate(-2 -2.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136,55.24c0-2.54-2.35-3.8-6.24-3.8a45.36,45.36,0,0,0-10.94.42c-12,1.13-24.38,2.64-36.42,3.76a25.44,25.44,0,0,1,.8,3.9,25.46,25.46,0,0,1,5.55,13.61c9.18-.89,18.35-1.84,27.72-2.69,11.72-.85,7.82,3.39,10.16,6.77,2.35,2.54,7.82,2.54,8.6-.42A97.8,97.8,0,0,0,136,55.24Z",
    transform: "translate(-2 -2.34)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 85.28,
    y: 91.83,
    width: 31.73,
    height: 12.86
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceInvoice);
export default __webpack_public_path__ + "static/media/finance_invoice.935e03ef.svg";
export { ForwardRef as ReactComponent };